import React, { useState } from 'react';
import './Login.css';
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { auth } from '../firebase';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { changeLanguage } from "../modules/modules";


const Login = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        // Handle login logic here
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in 
                // const user = userCredential.user;
                // console.log('User logged in:', user);
                navigate('/');
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                // console.log('Error logging in:', errorCode, errorMessage);
                alert(errorCode);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h2>DATY ADMIN</h2>
                    <p>{t('authorized-for-daty-abaya-tz-admin-only')}</p>
                </div>
                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">{t('email')}</label>
                        <input
                            type="email"
                            id="email"
                            placeholder={t('enter-your-email')}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">{t('password')}</label>
                        <input
                            type="password"
                            id="password"
                            placeholder={t('enter-your-password')}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-options">
                        <a href="/forget-password" className="forgot-password" >
                            {t('forget-password')}
                        </a>
                    </div>
                    {
                        loading ? (
                            <div className="loader"></div>
                        ) : (
                            <button type="submit" className="login-btn">
                                {t('sign-in')}
                            </button>
                        )
                    }

                </form>
                <a href="/" target='_parent' style={{ textDecoration: "none"}}>
                    {t('back-to-main-page')}
                </a><br />
                {
                    i18n.language === "sw" ? (
                        <button style={{ textDecoration: "none",border: "none", backgroundColor:"transparent", color:"black"}} onClick={() => changeLanguage("en")}>
                            english
                        </button>
                    ) : (
                        <button style={{ textDecoration: "none",border: "none", backgroundColor:"transparent", color:"black" }} onClick={() => changeLanguage("sw")}>
                            swahili
                        </button>
                    )
                }
            </div>
        </div>
    );
};

export default Login;
